var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "spinner-grow align-middle text-center",
      class: { "spinner-grow-sm": _vm.small },
      style: { visibility: _vm.show ? "visible" : "hidden" }
    },
    [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }